import { render, staticRenderFns } from "./taskInfoEdit.vue?vue&type=template&id=dfa760c0&scoped=true"
import script from "./taskInfoEdit.vue?vue&type=script&lang=js"
export * from "./taskInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./taskInfoEdit.vue?vue&type=style&index=0&id=dfa760c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa760c0",
  null
  
)

export default component.exports